export class AutoCompleteAddress {

  public description: string;
  public country: string;
  public countryCode: string;
  public latitude: number;
  public longitude: number;

  public static fromDto(d: any): AutoCompleteAddress {
    if (!d) {
      return null;
    }

    const autocompleteAddress = new AutoCompleteAddress();

    autocompleteAddress.description = d.description;
    autocompleteAddress.country     = d.country;
    autocompleteAddress.countryCode = d.country_code;
    autocompleteAddress.latitude    = d.latitude;
    autocompleteAddress.longitude   = d.longitude;

    return autocompleteAddress;
  }
}
